<template lang="pug">
  div version:{{ appVersion }}
</template>

<script>
export default {
  name: 'Health',
  data () {
    return {
      appVersion: '',
    };
  },
  created() {
    this.appVersion = process.env.VUE_APP_VERSION;
  },
};
</script>
